import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSearchFilter = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 15,
	viewBox: "0 0 14 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.9059 14.0305L7.91836 9.04297C7.55586 9.34297 7.12461 9.58047 6.62461 9.75547C6.12461 9.93047 5.59336 10.018 5.03086 10.018C3.61836 10.018 2.42773 9.53047 1.45898 8.55547C0.490235 7.58047 0.00585938 6.40547 0.00585938 5.03047C0.00585938 3.65547 0.493359 2.48047 1.46836 1.50547C2.44336 0.530469 3.61836 0.0429688 4.99336 0.0429688C6.38086 0.0429688 7.55586 0.530469 8.51836 1.50547C9.48086 2.48047 9.96211 3.65547 9.96211 5.03047C9.96211 5.58047 9.88086 6.09922 9.71836 6.58672C9.55586 7.07422 9.31211 7.53672 8.98711 7.97422L13.9934 12.943L12.9059 14.0305ZM5.01211 8.51797C5.97461 8.51797 6.79336 8.17734 7.46836 7.49609C8.14336 6.81484 8.48086 5.99297 8.48086 5.03047C8.48086 4.06797 8.14336 3.24609 7.46836 2.56484C6.79336 1.88359 5.97461 1.54297 5.01211 1.54297C4.02461 1.54297 3.19023 1.88359 2.50898 2.56484C1.82773 3.24609 1.48711 4.06797 1.48711 5.03047C1.48711 5.99297 1.82773 6.81484 2.50898 7.49609C3.19023 8.17734 4.02461 8.51797 5.01211 8.51797Z",
		fill: "#3C59F6"
	})
});
export default SvgSearchFilter;
